import { render, staticRenderFns } from "./OrganizationCharts.vue?vue&type=template&id=801915c4&scoped=true"
import script from "./OrganizationCharts.vue?vue&type=script&lang=js"
export * from "./OrganizationCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801915c4",
  null
  
)

export default component.exports